module.exports = __webpack_public_path__ + "static/headwind-og-image-9e9a6c7488ed0780339d514a29981b4c.png";